import React, { useState, useRef } from "react";
import { CustomerRCTAccountSettingsDto, CustomerRCTCalculationSettingsDto } from "interfaces/Mueller.Business.Models";
import CustomerRCTAccountSettingsForm from "./CustomerRCTAccountSettingsForm";
import CustomerRCTCalcSettingsForm from "./CustomerRCTCalcSettingsForm";

interface CustomerRCTSettingsCombinedProps {
  customerNumber: number;
  accountSettings: CustomerRCTAccountSettingsDto;
  calcSettings: CustomerRCTCalculationSettingsDto;
  onSave: (accountSettings: CustomerRCTAccountSettingsDto,  calcSettings: CustomerRCTCalculationSettingsDto) => void;
  onCancel: () => void;
  canEdit: boolean;
  portalTargetClass: string;
}

const formSteps = {
  AccountSettings: "AccountSettings",
  CalcSettings: "CalcSettings",
};

const CustomerRCTSettingsCombined = (props: CustomerRCTSettingsCombinedProps) => {
  const [currentStep, setCurrentStep] = useState<string>(formSteps.AccountSettings);
  const accountSettingsEdit = useRef<CustomerRCTAccountSettingsDto>(props.accountSettings);
  const calcSettingsEdit = useRef<CustomerRCTCalculationSettingsDto>(props.calcSettings);

  const onSaveAccountSettings = (settings: CustomerRCTAccountSettingsDto) => {
    accountSettingsEdit.current = settings;
    setCurrentStep(formSteps.CalcSettings);
  };
  
  const onSaveCalcSettings = (calcSettings: CustomerRCTCalculationSettingsDto) => {
    props.onSave(accountSettingsEdit.current, calcSettings);
  };
  const onCancelCalcSettings = (calcSettings: CustomerRCTCalculationSettingsDto) => {
    calcSettingsEdit.current = calcSettings;
    setCurrentStep(formSteps.AccountSettings);
  };

  // Render

  switch(currentStep) {
    case formSteps.AccountSettings:
      return (
        <>
          <p>{props.accountSettings.calcToolName} Account Settings</p>
          <CustomerRCTAccountSettingsForm
            customerNumber={props.customerNumber}
            settings={accountSettingsEdit.current}
            onNext={onSaveAccountSettings}
            onCancel={props.onCancel}
            canEdit={props.canEdit}
            portalTargetClass={props.portalTargetClass}
          />
        </>
        );
    case formSteps.CalcSettings:
      return (
        <>
          <p>RCT Calculation Settings</p>
          <p>These settings are applied for all RCT calcs setup for this account.</p>
          <CustomerRCTCalcSettingsForm
            customerNumber={props.customerNumber}
            settings={calcSettingsEdit.current}
            onSave={onSaveCalcSettings}
            onBack={onCancelCalcSettings}
            canEdit={props.canEdit}
            portalTargetClass={props.portalTargetClass}
          />
        </>
        );
  }
};

export default CustomerRCTSettingsCombined;